module.exports = __webpack_public_path__ + "img/全部绑定.bc57fe60.svg";